import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api";
export default function EditCareer() {
  const { id } = useParams(); // Get career ID from URL
  const navigate = useNavigate(); // For navigation after update
  const alert = useSwal();

  // State to hold form data
  const [formData, setFormData] = useState({
    heading: "",
    content: "",
  });
  const [loading, setLoading] = useState(false);
  // Fetch existing career data when component mounts
  useEffect(() => {
    const fetchCareer = async () => {
      try {
        const response = await api.post(`/updatebycareer/${id}`);
        setFormData({
          heading: response.data.heading,
          content: response.data.content,
        });
      } catch (error) {
        console.error("❌ Error fetching career:", error);
        alert("error", "Failed to fetch career details");
      }
    };

    if (id) {
      fetchCareer();
    }
  }, [id, alert]);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangereactuill = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value, // Directly update 'content' without event.target
    }));
  };

  // Handle form submission (update career)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await api.post(`/editCareer/${id}`, formData); // ✅ FIXED: Use PUT request
      alert("success", "Career Edit successfully!");
      navigate("/career"); // Redirect after update
    } catch (error) {
      console.error("❌ Error updating career:", error);
      alert("error", "Failed to update career details");
    }finally {
      setLoading(false);
    }
  };
  return (
    <section className="dashboardpage">
      <Header pageTitle="Edit Job Post Details" backTo="/career" />
      <div className="pageLeftspace">
        {/* Back to Events Link */}
        <div className="d-flex justify-content-start col-xl-6 col-12">
          <form className="form-fields d-flex" onSubmit={handleSubmit}>
            <div className="grid-container user">
              {/* Heading Input */}
              <div className="input-container">
                <input
                  type="text"
                  id="heading"
                  name="heading"
                  placeholder="Enter Job Title"
                  value={formData.heading}
                  onChange={handleChange}
                  required
                />
                {/* <label htmlFor="heading">Heading</label> */}
                <span className="underline"></span>
              </div>
              {/* Content Input */}
              <div className="input-container description-container">
                <ReactQuill
                  value={formData.content}
                  onChange={handleChangereactuill}
                  theme="snow"
                  placeholder=" "
                  className="react-quill-wrapper"
                />
              </div>
              {/* <button className="btn btn-purpal" type="submit">
                Update
              </button> */}

                        <button className="btn btn-purpal" type="submit" disabled={loading}>
  {loading ? "updating..." : "Update"}
</button>
            </div>
            {/* Submit Button */}
          </form>
        </div>
      </div>
    </section>
  );
}
